// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:23+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            afade2c873219795095fb5a6c713e81e
//    Signature:      eyJpdiI6ImhSa29ZZ3pYRUUxNlBWNFU5MmduWmc9PSIsInZhbHVlIjoiUU9KeUlRUzQrUmJveDJhWHdlWEEra0RNS0RTREZMRjlYTnRHaFQ3ZE85OTFucXo2ckMzZmZOVGFRbDMwYXo1RmZERjdNZ3k4UXJuUnhsbmlzY3JrdVNqMUE1Zkw3bVFlZkFqNEhQS0VKdXBUTzZYaW5iaEwydDdHQWxzTnZPNlFDdlVOaEhKeWRTUTBaS2Y0MGZVa0JGbnI0bVR2d1pVVTB6aGp1Z0NwQmc3TDhsSVFIYTRMZUZ6a2l5NW5GZWVsb1ZSdGVvWWxqeGFoNlE2dExydW50U09sNU1LcVoybjVLaTFPSm0rWGZxOHBnTUhTT0ZtbXlUd1RzVWxaMnBRTXV5Y2JCMENIenVnWXF5TlphUUx2cGltZG80VGJ6ZkM0TmJYbHZrMzgydmo5cjBqbkNMVk9iaXFDcitmYmJ3YjZTKzRkdGExd1lONW1ZY2EyR1ZXZE5KaE40ZnM5VzNCaDVXUmxlS0haek1ZUkowZlJJQ3VZblg0VitrZndudXl6Y3BVTUp6ZDl6NDk2OEtiNUlJbTJ1UT09IiwibWFjIjoiYmExM2Q0OGJlZjFlNWE4YTIwYWVjNGYzYWU0NzBkZTY1ZjI1ZTc0ZWNmZWRkODAzNjVkYTQ0YzYyZjcwZDhjNyJ9
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
